import React from 'react';

export const Preloader = (props: any) => {

    return (
        <React.Fragment>
            {/* Preloader */}
            <div className="metaportal_fn_preloader">
                <div className="loading-container">
                    <div className="loading">
                        <div className="l1">
                            <div></div>
                        </div>
                        <div className="l2">
                            <div></div>
                        </div>
                        <div className="l3">
                            <div></div>
                        </div>
                        <div className="l4">
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* !Preloader  */}

        </React.Fragment>
    )


}





